// GENERATED FILE - DO NOT MODIFY
export enum ProcoreOrderType {
    PurchaseOrder = 0,
    WorkOrder = 1,
    ChangeOrder = 2,
    StockOrder = 3,
}

export let nameof = "ProcoreOrderType";
